import QS from 'qs';
import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getOrderList(
  {
    page, size, direction, sort, ifs, orderNo, startAt, endAt, city, isWarn,orderStatus, customer, express
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/orders`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      ifs,
      orderNo,
      startAt,
      endAt,
      city,
      isWarn,
      orderStatus,
      customer,
      express
    },
  });
}

export function getRecentOrder() {
}

export function findOrder(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/order/${ id }`,
    method: 'get',
  });
}

export function getOrder(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/order-details/${ id }`,
    method: 'get',
  });
}

export function getGpsDatas(
  {
    ifsNo, gpsId, lat, lng, startTime, endTime,
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/simple-gps-datas`,
    method: 'get',
    params: {
      ifsNo,
      gpsId,
      lat,
      lng,
      startTime,
      endTime,
    },
  });
}

export function lastGpsLocation(
  {
    gpsId, startTime, endTime,
  },
) {
  return fetch({
    // url: '/gps-api/last-gps-data',
    url: `${ process.env.VUE_APP_BASE_URL }/last-gps-data`,
    method: 'get',
    params: {
      gpsId,
      startTime,
      endTime,
    },
  });
}

export function getCity() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/send-city-list`,
    method: 'get',
  });
}

export function getOrderNo() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/send-orderNo-list`,
    method: 'get'
  })
}

export function getExpress() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/send-express-list`,
    method: 'get'
  })
}

export function getCustomer() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/send-customer-list`,
    method: 'get'
  })
}

export function updateWarnOrder(id, cancelWarningReason) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/orders-warn-reason/${ id }`,
    method: 'post',
    params: { cancel: cancelWarningReason },
  });
}

export function updateOrder(order) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/orders`,
    method: 'patch',
    data: order,
  });
}

export function updateOrders(order) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/update_orders`,
    method: 'patch',
    data: order,
  });
}

export function findOrderSalesman(orderId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/salesmanOrder/${ orderId }`,
    method: 'get',
  });
}

export function saveOrderSalesman(orderId, orderSalesmanTels) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/salesmanOrder/${ orderId }`,
    method: 'post',
    data: QS.stringify({ orderSalesmanTels }),
  });
}

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getWarningOrderList(
  {
    startAt, endAt, status, page, size, ifs, transportType,warnReason, sendCity, sort, direction,
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warning-orders-list`,
    method: 'get',
    params: {
      startAt,
      endAt,
      status,
      page,
      size,
      ifs,
      transportType,
      warnReason,
      sendCity,
      sort,
      direction,
    },
  });
}

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getWarnData() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warn-data`,
    method: 'get',
  });
}

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function timeLine(
  {
    orderNo, expressCode, wmsNo, ifsNo
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/time-line`,
    method: 'get',
    params: {
      orderNo,
      expressCode,
      wmsNo,
      ifsNo
    },
  });
}

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getDataByWmsNo(
  {
    wmsNo,
    ifsNo
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/order-detail-by-wmsNo-or-ifsNo`,
    method: 'get',
    params: {
      wmsNo,
      ifsNo
    },
  });
}

export function getDataByIfsNo(
  {
    ifsNo,
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/order-detail-by-ifsNo`,
    method: 'get',
    params: {
      ifsNo,
    },
  });
}


/**
 * 查询所有仓库信息
 * @return
 */
export function getWarehousenoList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warehouseno-list`,
    method: 'get',
  });
}


export function changeCollectTime(collectGoodsForm) {
  // return null;
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/change-collect-time`,
    method: 'post',
    params: {
      id: collectGoodsForm.id,
      time: collectGoodsForm.collectTime
    }
  })

}


export function getTxt() {
  // return null;
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/getData`,
    // url: `${process.env.VUE_APP_BASE_URL}/hock-status-exception`,
    method: 'get',
  })

}
